import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@web-chat-core/ui-kit';
import { useMediaQuery } from 'react-responsive';
import { Logo } from 'ui/components/Logo/Logo';
import { isWebinarEnabled } from 'useCase/webinar/webinarStatus';
import { BadgeLabel, BadgeWrapper, Separator } from './view';

export const Badge = observer(() => {
    const { t } = useTranslation();
    const isCompact = useMediaQuery({ query: '(max-width: 1069px)' });

    const isWebinarMode = isWebinarEnabled();

    if (!isWebinarMode) return <Logo />;

    return (
        <Tooltip label={t('vks_webinar_mode_description')} position="top" sideOffset={18}>
            <BadgeWrapper>
                <Logo />
                {!isCompact && (
                    <>
                        <Separator />
                        <BadgeLabel variant="caption4">{t('vks_webinar_mode_title')}</BadgeLabel>
                    </>
                )}
            </BadgeWrapper>
        </Tooltip>
    );
});
